import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import styles from './stepperItem.module.scss';
import { log } from 'core-js';

class StepperItem extends Component {
    constructor(props) {
        super(props);
        let { isLinkVisited, isCurrentLink } = props;

        this.state = {
            lineStyle: !isLinkVisited ? this.getLineStyle() : {},
            pointerStyle: !isLinkVisited ? this.getCursorStyle() : {},
            textStyle: !isCurrentLink ? this.getTextStyle() : {},
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setComponentStyles(nextProps);
    }

    setComponentStyles = (props) => {
        let { isLinkVisited, isCurrentLink } = props;
        this.setState({
            lineStyle: !isLinkVisited ? this.getLineStyle() : {},
            pointerStyle: !isLinkVisited ? this.getCursorStyle() : {},
            textStyle: !isCurrentLink ? this.getTextStyle() : {},
        })
    }

    getLineStyle = () => {
        return {
            opacity: 0.1
        };
    }

    getCursorStyle = () => {
        return {
            cursor: 'initial'
        };
    }

    getTextStyle = () => {
        return {
            opacity: 0.3
        };
    }

    getImageOverLay = (isCurrentLink, isLinkVisited, url) => {
        if (!isLinkVisited) {
            return <div className={styles['image-overlay-notvisited']} />
        } else {
            return <Fragment>
                {
                    (!isCurrentLink && isLinkVisited) ?
                        <Link to={url}>
                            <div className={styles['image-overlay-visited']} />
                        </Link>
                        :
                        null
                }
            </Fragment>
        }
    }

    render() {
        const { url, imageUrl, text, isFirstItem, isCurrentLink, isLinkVisited } = this.props;
        const { lineStyle, pointerStyle, textStyle } = this.state;

        return (
            <div className={styles['stepper-image-container']}>
                {
                    !isFirstItem ?
                        <div className={styles['image-connector-line']} style={lineStyle} />
                        :
                        null
                }
                <div className={styles['intro-image-box']}>
                    <div className={styles['intro-images-container']}>
                        <Link to={url} style={{ height: '100 %', width: '100 %', position: 'relative' }}>
                            <img src={imageUrl} className={styles['image-style']} />
                            {this.getImageOverLay(isCurrentLink, isLinkVisited, url)}
                        </Link>
                    </div>
                    <div className={styles['intro-image-desc']} style={{ ...pointerStyle, ...textStyle }} >{text}</div>
                </div>
            </div>

        )
    }
}

export default StepperItem;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/stepper/stepperItem/StepperItem.js